export type Prettify<T> = {
  [K in keyof T]: T[K];
} & {};


export const isValidPhoneNumber = (val: string | null | undefined): boolean => {
  if (val == null || val === "") return true; // allow empty if .optional().nullable()
  return /^(?=[^+]*\+?[^+]*$)[0-9+ -]+$/.test(val);
};

